import { DownOutlined } from '@ant-design/icons';
import { Typography } from 'antd';

import useAPIQuery from '../../api/useAPIQuery';
import { AICollapse } from '../components/AIAlert';
import { aiPurple } from '../constants/colors';
import { SparkIcon } from '../icons/spark';

export const AICandidateResumeSummary: React.FC<{
  candidateId: number;
}> = ({ candidateId }) => {
  const config = useAPIQuery('/configs/tenant-configurations/');
  const { data: resume } = useAPIQuery(`/candidates/${candidateId}/`, {
    select: (data) => data.resume_summary,
    enabled: !!config.data?.enableCandidateResumeSummary && !!candidateId,
  });

  if (!config?.data?.enableCandidateResumeSummary || !resume) {
    return null;
  }

  return (
    <AICollapse
      bordered={false}
      expandIconPosition="end"
      expandIcon={({ isActive }) => (
        <DownOutlined rotate={isActive ? 180 : 0} style={{ fontSize: '1.3em', color: aiPurple }} />
      )}
      defaultActiveKey={`resume_summary-${candidateId}`}
    >
      <AICollapse.Panel
        header={
          <div style={{ display: 'flex', alignItems: 'center', width: '92%' }}>
            <SparkIcon
              style={{
                fontSize: '1.5em',
                color: aiPurple,
                marginRight: '0.5em',
              }}
            />
            <span>
              <b>Resumo de Currículo:</b> Confira abaixo o resumo do currículo do candidato, gerado
              pela Synapses, a inteligência artificial da Mindsight.
            </span>
          </div>
        }
        key={`resume_summary-${candidateId}`}
      >
        <Typography.Paragraph style={{ whiteSpace: 'pre-line' }}>{resume}</Typography.Paragraph>
      </AICollapse.Panel>
    </AICollapse>
  );
};
